<template>
  <v-container fluid fill-height ma-0 pa-0>
    <v-dialog
      v-model="finishDialog"
      max-width="406"
      flat
      elevation="0"
      persistent
    >
      <div id="confetti-container"></div>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title class="justify-center pb-0 mb-0 defaultColor--text">
          {{ "TEBRİKLER" }}
        </v-card-title>
        <v-card-actions class="justify-center align-center mt-4">
          <h3>
            {{ giftName }}
          </h3>
        </v-card-actions>
        <v-card-actions class="justify-center align-center pb-5 mt-0">
          <h3>
            {{ "kazandın" }}
          </h3>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="$router.push('home')" />
    </v-dialog>
    <v-layout
      row
      wrap
      fill-height
      align-center
      justify-center
      style="min-width: 1200px"
      v-if="status === 0"
    >
      <div style="bottom: 90px; position: fixed" class="whellContainer">
        <!-- <v-btn @click="startWhell">ÇEVİR</v-btn> -->
        <div
          align="center"
          valign="center"
          id="canvasContainer"
          style="width: 900px"
        >
          <canvas
            id="canvas"
            height="900"
            width="618"
            style="margin-left: auto; margin-right: auto; margin-top: -100px"
          >
          </canvas>
          <img
            id="prizePointer"
            :src="require('../../../public/images/wheel/b.png').default"
            alt="V"
          />
        </div>
        <div class="d-flex justify-center" style="width: 100%">
          <v-btn
            @click="startWhell"
            color="defaultColor"
            large
            width="200"
            height="70"
            dark
            >ÇEVİR KAZAN</v-btn
          >
        </div>
        <div id="confetti-container"></div>
      </div>
    </v-layout>

    <v-layout
      row
      wrap
      fill-height
      align-center
      justify-center
      style="min-width: 1200px"
      v-if="status === 1"
    >
      <div>hediyeyi görmüş kazanmış</div>
    </v-layout>

    <v-layout
      row
      wrap
      fill-height
      align-center
      justify-center
      style="min-width: 1200px"
      v-if="status !== 1 && status !== 0 && status !== null"
    >
      <div>Hakkın bulunmamaktadır</div>
      <v-btn @click="$router.push('home')">Ana Ekrana Dön</v-btn>
    </v-layout>
  </v-container>
</template>


<script>
import DialogCloseButton from "../../components/General/DialogCloseButton.vue";
import GiftService from "../../services/GiftService";
var theWheel; 
export default {
  data() {
    return {
      WheelData: {
        numSegments: 20, // Specify number of segments.
        outerRadius: 260, // Set outer radius so wheel fits inside the background.
        textFontSize: 14,
        drawMode: "image",
        imageOverlay: true,
        strokeStyle: "transparent",
        responsive: true,
        textAlignment: "center",
        textMargin: 15,
        lineWidth: 1, // Set font size as desired.
        // wheelPhotoPath: require("../../../public/images/wheel/TurkcellWheel.png").default,
        wheelPhotoPath: null,
        // Specify the animation to use.
        animation: {
          type: "spinToStop",
          duration: 8, // Duration in seconds.
          spins: 6, // Number of complete spins.
          callbackFinished: this.finishedWheel,
          callbackSound: this.callBackWheel,
        },
      },

      wheelIndex: null,
      giftName: "",
      wheelCount: null,
      wheelSpinning: false,
      spin: "",

      finishDialog: false,

      //Confetti
      settings: {
        numConfetti: 100,
        distance: 250,
        colors: ["blue", "green", "yellow", "red", "pink"],
        shapes: ["square", "circle", "rectangle"],
        symbol: [
          "starRed",
          "starYellow",
          "starBlue",
          "springYellow",
          "springYellow",
          "starpingPing",
          "lineYellow",
          "linePink",
          "lineBlue",
        ],
      },

      status: null,
    };
  },
  components: {
    DialogCloseButton,
  },
  methods: {
    //TODO:
    //statu 0 dışındaki ekranların UI ları yapılacak
    //Kişinin çarkı çevirip çeviremeyeceği bilgisi web sitesi ilk açıldığında alınıp store a yazılacak
    //O bilgi bu sayfada kontrol edilecek
    
    getGift() {
      setPageLoading(true);
      GiftService.getUserStatus()
        .then((res) => {
          let data = res.data;
          this.status = data.GiftStatus;
          if (data.GiftStatus === 0) {
            //this.wheelIndex = data.WheelIndex;
            this.wheelCount = data.WheelCount;
            this.WheelData.numSegments = data.WheelCount;
            this.WheelData.wheelPhotoPath = data.WheelUrl;
            //this.WheelData.wheelPhotoPath = 'http://hmnsdevapi.digitusdev.com/uploads/Resized_Image/1672414045_1672312109_wheel-image.png'
            setTimeout(() => {
              this.setDefaultWheel();
            }, 200);
          }
        })
        .catch((err) => {
          showError(err);
          this.loading = false;
        })
        .then(() => {
          setPageLoading(false);
        });
    },

    setDefaultWheel() {
      // sounds
      this.audio = new Audio(require("../../../public/sound/tick.mp3"));
      this.acclamation = new Audio(
        require("../../../public/sound/acclamation.mp3").default
      );

      //Wheel
      theWheel = new Winwheel(this.WheelData);
      this.selectedItem = this.giftName;
      let loadedImg = new Image();
      loadedImg.src = this.WheelData.wheelPhotoPath;
      loadedImg.onload = function () {
        theWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
        // theWheel.wheelImage.width = '618'
        // theWheel.wheelImage.height = '500'
        // theWheel.wheelImage.style.width = "618px"
        // theWheel.wheelImage.style.height = "618px"
        //theWheel.wheelImage.style.display = "block"
        // theWheel.wheelImage.style.objectFit = 'contain'
        // theWheel.wheelImage.style.zoom = 0.5
        //console.log("asdasd : ", theWheel);
        // theWheel.draw(); // Also call draw function to render the wheel.
        // var hRatio = theWheel.canvas.width / loadedImg.width;
        // var vRatio = theWheel.canvas.height / loadedImg.height;
        // var ratio = Math.min(hRatio, vRatio);
        // theWheel.ctx.drawImage(
        //   loadedImg,
        //   0,
        //   0,
        //   loadedImg.width,
        //   loadedImg.height,
        //   0,
        //   0,
        //   loadedImg.width * ratio,
        //   loadedImg.height * ratio
        // );
        theWheel.draw(loadedImg);
      };
    },

    startWhell() {
      GiftService.spinWheel()
        .then((res) => {
            console.log('aasd :' , res.data)
          let data = res.data.Result;
          this.giftName = data.GiftName;
          this.wheelIndex = data.WheelIndex + 1;
          this.wheelLoad();
        })
        .catch((err) => {
          showError(err);
          this.loading = false;
        })
        .then(() => {});
    },

    wheelLoad() {
      if (this.wheelSpinning == false) {
        // Based on the power level selected adjust the number of spins for the wheel, the more times is has
        // to rotate with the duration of the animation the quicker the wheel spins.

        // spin
        this.spin = document.getElementById("prizePointer");

        theWheel.animation.stopAngle = this.getStopDegree();
        // Disable the spin button so can't click again while wheel is spinning.
        // //console.log("asd : ", theWheel.animation.stopAngle);

        // Begin the spin animation by calling startAnimation on the wheel object.,
        theWheel.startAnimation();
        // Set to true so that power can't be changed and spin button re-enabled during
        // the current animation. The user will have to reset before spinning again.
        this.wheelSpinning = true;
      }
    },

    getStopDegree() {
      this._StopIndex = this.wheelIndex;
      console.log("this._StopIndex  :", this._StopIndex);
      this.selectedItem = this.giftName;
      let degree = 0;
      let index = this._StopIndex;
      let space = 360 / this.wheelCount;
      let min = (index - 1) * space + 5;
      let max = index * space - 5;
      degree = Math.floor(Math.random() * (max - min)) + min;
      return degree;
    },

    playSoundTick() {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.play();
    },

    playSoundAcclamation() {
      this.acclamation.pause();
      this.acclamation.currentTime = 0;
      this.acclamation.play();
    },

    callBackWheel() {
      this.moveSpin();
      this.playSoundTick();
    },

    moveSpin() {
      this.spin.style.webkitTransform = "rotate(" + -25 + "deg)";
      setTimeout(() => {
        this.spin.style.webkitTransform = "rotate(" + 0 + "deg)";
      }, 100);
    },

    startConfetti() {
      var container = document.getElementById("confetti-container");
      var containerRect = container.getBoundingClientRect();
      var containerData = {
        x: containerRect.left,
        y: containerRect.top,
        height: containerRect.right - containerRect.left,
        width: containerRect.bottom - containerRect.top,
      };

      var start = {
        x: containerData.x + containerData.width / 2,
        y: containerData.y + containerData.height / 2,
      };

      var maxY =
        containerData.y + containerData.height + this.settings.distance;
      var minY = containerData.y - this.settings.distance;

      var maxX = containerData.x + containerData.width + this.settings.distance;
      var minX = containerData.x - this.settings.distance;

      var docFrag = document.createDocumentFragment();

      for (var i = 0; i < this.settings.numConfetti; i++) {
        let confetti = document.createElement("div");
        let color = this.getRandomArrayItem(this.settings.colors);
        let shape = this.getRandomArrayItem(this.settings.shapes);
        let size = this.getRandomInt(30, 10);
        let newX = this.getRandomInt(minX, maxX);
        let newY = this.getRandomInt(minY, maxY);
        let symbol = this.getRandomArrayItem(this.settings.symbol);
        confetti.className += "confetti " + symbol + " " + shape;

        if (
          color == "blue" ||
          color == "yellow" ||
          color == "green" ||
          color == "pink" ||
          color == "red"
        ) {
          confetti.className = "confetti " + color + " " + shape;
          confetti.style.height = size + "px";
          confetti.style.width = size + "px";
          confetti.style.background = this.getRandomArrayItem(
            this.settings.colors
          );
        }

        confetti.style.top = start.y + "px";
        confetti.style.left = start.x + "px";

        confetti.style.transform = "rotate(" + this.getRotation() + "deg)";
        docFrag.appendChild(confetti);

        setTimeout(() => {
          confetti.style.transition =
            "all " + this.getRandomFloat(1.5, 0.5) + "s ease";
          confetti.style.top = newY + "px";
          confetti.style.left = newX + "px";
          confetti.style.transform = "rotate(" + this.getRotation() + "deg)";

          confetti.addEventListener("transitionend", () => {
            confetti.style.transition =
              "all " + this.getRandomFloat(1.25, 1) + " ease";
            confetti.style.opacity = 0;
            confetti.style.transform = "rotate(" + this.getRotation() + "deg)";
            confetti.style.top = parseInt(confetti.style.top) + 10 + "px";

            setTimeout(() => {
              if (confetti.parentNode) {
                confetti.parentNode.removeChild(confetti);
              }
            }, 1000);
          });
        }, 50);
      }
      document.body.appendChild(docFrag);
    },

    getRandomArrayItem(array) {
      return array[Math.floor(Math.random() * array.length)];
    },

    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },

    getRandomFloat(min, max) {
      return Math.random() * (max - min) + min;
    },

    getRotation() {
      return Math.floor(Math.random() * 360) + 1;
    },

    finishedWheel() {
      this.sendGiftStatus();
      this.playSoundAcclamation();
      this.soundStatus = false;
      clearInterval(this.soundIntervel);
      setTimeout(() => {
        this.finishDialog = true;
      }, 1000);
      
      setTimeout(() => {
        this.startConfetti();
      }, 1500);
    },

    sendGiftStatus() {
      GiftService.winGift()
        .then((res) => {})
        .catch((err) => {
          showError(err);
          this.loading = false;
        })
        .then(() => {});
    },
  },
  mounted() {
    this.getGift();
  },
  computed: {},
  watch: {},
};
</script>

<style>
@import "../../../public/css/wheelConfetti.scss";
.background {
  /* background-image: url("../../../public/images/wheel/bg2.png"); */
  background-position: bottom;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#canvasContainer {
  background-image: url("../../../public/images/wheel/whellBorder2.png");
  /*background-color: blue;*/
  background-position-x: center;
  background-position-y: center;

  background-size: 700px;
  background-repeat: no-repeat; /* Ensure that background does not repeat */
  background-position: center; /* Ensure image is centred */
  width: 100%; /* Width and height should at least be the same as the canvas */
  height: 100%;
  position: relative;
}

#prizePointer {
  position: absolute;
  left: 410px;
  top: -10px;
  z-index: 1;
}

.giftTextClass {
  animation-duration: 2s;
  animation-delay: 2s;
  animation-iteration-count: infinite;
}

.giftTextClass {
  line-height: 25px;
  font-size: 34px;
  color: #ffffff;
}

.dialogClass {
  border-radius: 30px !important;
  background-color: #64bc46 !important;
  color: white !important;
  z-index: 500;
  /*font-family: LuckiestGuy;*/
}

@media only screen and (max-height: 2000px) {
  .whellContainer {
    transform: scale(1.1);
    transform-origin: 50% 100%;
  }
}
@media only screen and (max-height: 1500px) {
  .whellContainer {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@media only screen and (max-height: 1200px) {
  .whellContainer {
    transform: scale(0.9);
    transform-origin: 50% 100%;
  }
}

@media only screen and (max-height: 1024px) {
  .whellContainer {
    transform: scale(0.8);
    transform-origin: 50% 100%;
  }
}
@media only screen and (max-height: 870px) {
  .whellContainer {
    transform: scale(0.7);
    transform-origin: 50% 100%;
  }
}
@media only screen and (max-height: 760px) {
  .whellContainer {
    transform: scale(0.58);
    transform-origin: 50% 100%;
  }
}

@media only screen and (max-height: 620px) {
  .whellContainer {
    transform: scale(0.5);
    transform-origin: 50% 100%;
  }
}
</style>
